var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShow)?_c('div',{staticClass:"readComplete anim",on:{"click":function($event){return _vm.pay()}}},[_vm._v("\n    ￥"+_vm._s(this.resultpage_price)+" 解锁8000字专业报告\n  ")]):_vm._e(),(_vm.isShow)?_c('div',{staticClass:"back anim",on:{"click":function($event){return _vm.goHome()}}},[_vm._v("返回首页")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }